import axios from "axios";
import API_BASE_URL from "../config";

const Contact_API = `${API_BASE_URL}/contact`; // Backend API URL


export const submitContact = async (contactData)  => {
    try {
      const response = await axios.post(`${Contact_API}/submit`, contactData);
      return response.data;
    } catch (error) {
      console.error("Error submitting contact form:", error.response?.data || error.message);
      
    
    return { 
      Success: false, 
      Message: error.response?.data?.Message || "An error occurred during signup." 
    }; // ✅ Instead of throwing, return an object
  }
};